// iterator-helpers-polyfill constructs a Proxy in its module body,
// so a plain `import` crashes pre-Proxy browsers (chrome <49) at load time.
const g: typeof globalThis = typeof globalThis !== 'undefined' ? globalThis : window;

if (
    typeof Proxy === 'function' &&
    (typeof g.Iterator === 'undefined' || typeof g.Iterator.prototype?.map !== 'function')
) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require('iterator-helpers-polyfill').installIntoGlobal();
}
